import { Amplify } from "aws-amplify";
import {
  fetchAuthSession,
  signIn,
  signOut,
  signUp,
  confirmSignUp,
  resetPassword,
  confirmResetPassword,
} from "aws-amplify/auth";

// AWS configuration for S3 access
// This configuration enables Amplify to work with our existing Firebase auth
// by providing identity pool access for S3 operations
const awsConfig = {
  // REQUIRED - Amazon Cognito Region
  region: "us-east-1",
  // Identity Pool ID for unauthenticated and authenticated access to S3
  identityPoolId: "us-east-1:6ae2de80-824a-43d4-aef7-b825ef284cf5",
  // User pool configuration (optional for S3 access with identity pool)
  userPoolId: "us-east-1_JEVVqUkes",
  userPoolWebClientId: "5h0udkrfr19lv61adffiqt70lo",
  // S3 bucket configuration
  storage: {
    s3: {
      bucket: process.env.REACT_APP_S3_BUCKET || "your-s3-bucket-name",
      region: "us-east-1",
    },
  },
};

// Configure Amplify for S3 access with existing Firebase auth
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.userPoolId,
      userPoolClientId: awsConfig.userPoolWebClientId,
      identityPoolId: awsConfig.identityPoolId,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: "code",
      userAttributes: {
        email: {
          required: true,
        },
      },
    },
  },
  Storage: {
    S3: {
      bucket: awsConfig.storage.s3.bucket,
      region: awsConfig.storage.s3.region,
    },
  },
});

// Export auth functions
export {
  fetchAuthSession,
  signIn,
  signOut,
  signUp,
  confirmSignUp,
  resetPassword,
  confirmResetPassword,
};

export default Amplify;
